import { api } from "./api";

export const createCategoryApi = (params) => {
    return api.post(`/category/create`, JSON.stringify(params));
};

export const editCategoryApi = (params) => {
    return api.post(`/category/edit`, JSON.stringify(params));
};

export const listCategoryApi = (params) => {
    return api.get(`/category/list`, { params });
};

export const viewCategoryApi = (params) => {
    return api.get(`/category/view`, { params });
};

export const deleteCategoryApi = (params) => {
    return api.delete(`/category/delete`, { params });
};